import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

const oauthConfigurationForIntranet: AuthConfig = {
  issuer: environment.intranet.issuer,
  redirectUri: environment.intranet.redirectUrl,
  postLogoutRedirectUri: environment.intranet.postLogoutRedirectUrl,
  clientId: environment.intranet.clientId,
  responseType: environment.responseType,
  scope: environment.scope,
  requireHttps: environment.requireHttps,
  oidc: environment.oidc,
  showDebugInformation: environment.showDebugInformation,
};

const oauthConfigurationForInternet: AuthConfig = {
  issuer: environment.internet.issuer,
  redirectUri: environment.internet.redirectUrl,
  postLogoutRedirectUri: environment.internet.postLogoutRedirectUrl,
  clientId: environment.internet.clientId,
  responseType: environment.responseType,
  scope: environment.scope,
  requireHttps: environment.showDebugInformation,
  oidc: environment.oidc,
  showDebugInformation: environment.showDebugInformation,
};

export { oauthConfigurationForInternet, oauthConfigurationForIntranet };
